import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bradwestfall/Desktop/ReactTraining/Projects/monorepo/reacttraining.com/src/page-templates/BlogArticlePage.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Today, we are excited to announce the release of `}<a parentName="p" {...{
        "href": "https://github.com/ReactTraining/react-router/releases/tag/v5.0.0"
      }}>{`React Router version 5`}</a>{`. You can get it using:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`$ `}<span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span>{` react-router
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# or`}</span>{`
$ `}<span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span>{` react-router-dom
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# or`}</span>{`
$ `}<span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span>{` react-router-native`}</code></pre></div>
    <h2 {...{
      "id": "tldr"
    }}><a parentName="h2" {...{
        "href": "#tldr",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`tl;dr`}</h2>
    <ul>
      <li parentName="ul">{`React Router version 5 is now available`}</li>
      <li parentName="ul">{`v5 is fully backwards compatible with 4.x`}<ul parentName="li">
          <li parentName="ul">{`The only reason for the major version bump has to do with how we were specifying dependencies in `}<code parentName="li" {...{
              "className": "language-text"
            }}>{`react-router-dom`}</code></li>
        </ul></li>
      <li parentName="ul">{`v5 introduces several structural improvements, including:`}<ul parentName="li">
          <li parentName="ul">{`Better support for React 16`}</li>
          <li parentName="ul">{`Eliminates all warnings in `}<code parentName="li" {...{
              "className": "language-text"
            }}>{`<StrictMode>`}</code></li>
          <li parentName="ul">{`New context API (internal only)`}</li>
          <li parentName="ul">{`Fully automated releases`}</li>
        </ul></li>
      <li parentName="ul">{`v5 also introduces a few new features`}</li>
    </ul>
    <h2 {...{
      "id": "structural-improvements"
    }}><a parentName="h2" {...{
        "href": "#structural-improvements",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Structural Improvements`}</h2>
    <p>{`This release is light on features and fixes, and is more focused on stability and compatibility and preparing the library for future releases.`}</p>
    <p><em parentName="p">{`There are no breaking changes in this release. If you are already using version 4.x, you can use version 5 immediately with zero code changes.`}</em>{` 🎉 Version 5 will pick up where `}<a parentName="p" {...{
        "href": "https://github.com/ReactTraining/react-router/issues/6497"
      }}>{`the 4.x roadmap `}</a>{` (now the 5.x roadmap) left off.`}</p>
    <p>{`The most significant improvement in v5 is better allaround support for React 16, while maintaining `}<strong parentName="p">{`full compatibility`}</strong>{` with React >= 15. We know that a lot of React Router users are maintaing apps they've built over the last few years using various versions of React 15 or 16 and React Router 4, and we are showing our committment to you with this release. This includes upgrading from using React's legacy context API, as well as eliminating all other `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`<StrictMode>`}</code>{` warnings. My sincere thanks to Tim Dorr for `}<a parentName="p" {...{
        "href": "https://github.com/ReactTraining/react-router/pull/5908"
      }}>{`getting the ball rolling here`}</a>{`, and my good friend Jared Palmer for prodding me along.`}</p>
    <p>{`Using the new context API in React 16 (we use `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/create-react-context"
      }}>{`Jamie Kyle's `}<code parentName="a" {...{
          "className": "language-text"
        }}>{`create-react-context`}</code>{` shim`}</a>{` for backwards compat with React 15) also allows us to avoid `}<a parentName="p" {...{
        "href": "https://github.com/ReactTraining/react-router/blob/ea8eba843bf899daf8a51c2617d05c179b38369d/packages/react-router/docs/guides/blocked-updates.md"
      }}>{`the "update blocking" problem`}</a>{` that you may have had to work around in the past.`}</p>
    <p>{`Side note: we have been `}<a parentName="p" {...{
        "href": "https://github.com/ReactTraining/react-broadcast"
      }}>{`working on this problem`}</a>{` for over 2 years now ... good to see it finally fixed! 😅`}</p>
    <p>{`Other housekeeping items in this release include a complete overhaul to our bundling infrastructure and full test coverage for all bundles we publish. Before this release we were only running tests on our source code, so there was a chance that our build introduced a bug somewhere. But now all our builds pass all our tests.`}</p>
    <p>{`We switched from publishing multiple files for each build to a single file in v5, just like React itself (we copied their code! 😉). We also introduced pre-optimized builds for production, so you don't have to manually set `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`process.env.NODE_ENV`}</code>{` to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`production`}</code>{` in your build script if you don't want to (though you probably still want to, for other stuff). The point is, you won't be building the router as part of your build. We've already taken care of that, in both development and production modes.`}</p>
    <p>{`Probably the most significant change here is that instead of requiring individual files from the router, you need to destructure your imports from the main bundle.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// Instead of:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` Router `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react-router/Router'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` Switch `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react-router/Switch'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// do:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` Router`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` Switch `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react-router'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <p>{`The former style is still supported but will issue a warning in development.`}</p>
    <p>{`In addition to these improvements, we did some work to streamline and automate the release process, so we should be able to release more frequently and predictably from now on.`}</p>
    <h2 {...{
      "id": "new-features"
    }}><a parentName="h2" {...{
        "href": "#new-features",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`New Features`}</h2>
    <p>{`One of the main new features in this release is `}<a parentName="p" {...{
        "href": "https://github.com/ReactTraining/react-router/pull/5889"
      }}>{`the ability to use an array in `}<code parentName="a" {...{
          "className": "language-text"
        }}>{`<Route path>`}</code></a>{`, so if you want to render the same component at 2 different route paths, you no longer have to create 2 routes.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// Instead of this:`}</span>{`
`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`Switch`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`Route path`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"/users/:id"`}</span>{` component`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`User`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`Route path`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"/profile/:id"`}</span>{` component`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`User`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{`Switch`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// you can now do this:`}</span>{`
`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`Route path`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"/users/:id"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"/profile/:id"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` component`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`User`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span></code></pre></div>
    <p>{`There are also a few fixes in this release, including support for `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`React.createRef`}</code>{` in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`<Link innerRef>`}</code>{` and support for using `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`React.forwardRef`}</code>{` in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`<Route component>`}</code>{`.`}</p>
    <h2 {...{
      "id": "why-the-major-version-bump"
    }}><a parentName="h2" {...{
        "href": "#why-the-major-version-bump",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Why the major version bump?`}</h2>
    <p>{`We originally intended to release React Router version 5 as 4.4, which we actually did last Friday. However, there was one major consequence which we didn't foresee, and it all boils down to a single character: `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`^`}</code>{`.`}</p>
    <p>{`We have always tried to do versioning as closely as possible to the way the React team does versioning for their packages. In version 4, we have been releasing all `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-router*`}</code>{` packages in lock step. This means that when you install e.g. `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-router-dom`}</code>{` version 4.3.0, it depends on `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-router`}</code>{` version 4.3.0. This makes it easy for people to know which version of each package they need, and is the same as `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-dom`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react`}</code>{` do.`}</p>
    <p>{`However, there's one subtle difference between `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-router-dom`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-dom`}</code>{`, which is that `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-router-dom`}</code>{` includes `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-router`}</code>{` as a dependency, not a `}<strong parentName="p">{`peer`}</strong>{` dependency. So in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-router-dom`}</code>{` version 4.3.1 we have a dependency on `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`"react-router": "^4.3.1"`}</code>{` (note the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`^`}</code>{`).`}</p>
    <p>{`At the time we released version 4.4 of both packages on Friday, we had been beta testing 4.4 for over 5 months. We had received tons of feedback over the course of `}<a parentName="p" {...{
        "href": "https://github.com/ReactTraining/react-router/releases"
      }}>{`8 separate beta releases`}</a>{` and squashed quite a few bugs, so we felt pretty confident that everything was ready for 4.4 final. But there was one case that we hadn't considered, which is that technically `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-router-dom`}</code>{` version 4.3.x could depend on `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-router`}</code>{` version 4.4, which they can't because of the changes to how we're using our internal context API. So although there were no public API breakages between 4.3.x and 4.4.0, there was a chance that some people could install 2 mismatched versions. What made this even trickier is that nobody noticed this bug until 4.4 was out of beta, because there was no chance you'd get a 4.4 beta installed alonside `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-router-dom`}</code>{` 4.3.x.`}</p>
    <p>{`In the end, we decided that the fix that would cause the least pain for everyone would be to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`npm unpublish`}</code>{` version 4.4.0 and re-release it as 5.0.0. This means that:`}</p>
    <ul>
      <li parentName="ul">{`Anyone using version 4.3.x will not get the version mismatch and`}</li>
      <li parentName="ul">{`people who want the new stable version (5.0.0) are still able to get it.`}</li>
    </ul>
    <p>{`We apologize for any pain this caused. To fix this problem going forward, we are pinning the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-router`}</code>{` dependency in each version of `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`react-router-dom`}</code>{` so there is no chance of a version mismatch. We may have a better solution for this in the future, but that's the safest thing for now.`}</p>
    <h2 {...{
      "id": "thanks"
    }}><a parentName="h2" {...{
        "href": "#thanks",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Thanks`}</h2>
    <p>{`This release was made possible by many contributors including Tim Dorr, Paul Sherman, Bogdan Chadkin, Dan Levy, Brandon John Lewis, Benjamin Atkin, Hongbo Miao, Ches Zhuravsky, Benjamin Johnson, Daniel Powell, Vernon de Goede, Sebastian Silbermann, Mateusz Burzyński, Ben Mason, Kevin Vicrey, Anthony Frehner, Saugat Acharya, Rick Hanlon II, Eugene Dzhumak, Tien Pham, Peter Fu, alireza-mh, gcangussu, JBallin, misacorn, and many others who contributed code, wrote documentation, or helped us during the beta testing phase.`}</p>
    <p>{`I'm sure I missed a few names, so if you helped out and I missed you, please let me know!`}</p>
    <p>{`Enjoy!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      